<template>
    <AnchorNavigationBarMobile @toggle="handleToggle" :title="model.elements.menu_title.value" v-if="model"/>
    <SmartLinkItemComponent :id="model?.system?.id" :component="!model?.system?.workflow" v-if="model">
        <div class="platform-split-content-block" v-if="expandSection || !isMobile" :id="`_${model?.system?.id}`" :class="backgroundColor" :index="index">
            <div class="container-fluid" :class="{'pt-0': paddingModifications['pt-0'], 'pb-0': paddingModifications['pb-0']}">

                <div class="row">
                    <div class="left-col" :class="[block_styling[0], mobile_block_styling[0]]" data-aos="fade-in">
                        <SmartLinkStandaloneElement :codename="type.elements.left_content.codename">
                            <RichText v-if="!isEmpty(model?.elements?.left_content?.value)" :value="model.elements.left_content.value" />
                        </SmartLinkStandaloneElement>
                    </div>
                    <div class="right-col" :class="[block_styling[1], mobile_block_styling[1]]" data-aos="fade-in">
                        <SmartLinkStandaloneElement :codename="type.elements.right_content.codename">
                            <RichText v-if="!isEmpty(model?.elements?.right_content?.value)" :value="model.elements.right_content.value" />
                        </SmartLinkStandaloneElement>
                    </div>
                </div>
                
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { contentTypes, type PlatformPageSplitContentBlockModel } from '~~/app/models';

const type = contentTypes.platform_page_split_content_block;
const props = defineProps<{ model: PlatformPageSplitContentBlockModel }>();

const { addItem, getBlockIndex } = useAnchorNavBar();

const {deviceIsMobile} = useScreenHelper();

const isMobile = ref(false);
const expandSection = ref(false);
const handleToggle = (expandState: boolean) => {
  expandSection.value = expandState
}
const index = computed(() => getBlockIndex(props.model.system.codename));

addItem(props.model.elements.show_in_anchor_bar,
    props.model.elements.title.value,
    `${props.model?.system?.id}`,
    props.model.system.codename);

const block_styling = computed(() => {
    switch (firstOrDefault(props.model.elements.layout.value)?.codename) {
        case 'n50_50':
            return ['col-lg-6', 'col-lg-6']
        default:
            return ['col-lg-6', 'col-lg-6']
    }
})

const mobile_block_styling = computed(() => {
    switch (firstOrDefault(props.model.elements.mobile_layout.value)?.codename) {
        case 'left_content_on_top':
            return ['', '']
        case 'right_content_on_top':
            return ['order-lg-1 order-2', 'order-lg-2 order-1']
        default:
            return ['', '']
    }
})

const paddingModifications = computed(() =>
    getPaddingModifications(props.model.elements.padding_modifications__padding_modifications)
)

const backgroundColor = computed(() => {
    switch (firstOrDefault(props?.model?.elements?.background?.value)?.codename) {
        case 'light':
            return 'bg-white';
        case 'dark':
            return 'bg-navy';
        default:
            return '';
    }
});

onMounted(() => {
    isMobile.value = deviceIsMobile();
    addEventListener("resize", (event) => {
        isMobile.value = deviceIsMobile();
    });
})
</script>